import { TimeLogApi, ToastStateHandler } from '../../../api';
import { getUserMessage, normalizeError } from '../../../api/utils/ErrorHandler';
import { ICallback } from '../../../commonTypes/hook.types';
import { MonthlySubmitRequestDto } from '../../../commonTypes/timelog.types';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpMonthlySubmitTimelogs = () => {
    const { t } = useTranslation();
    const timeLogApi: TimeLogApi = useContainer(TimeLogApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (body: MonthlySubmitRequestDto, callback?: ICallback) => {
        const { exec, abort } = timeLogApi.monthlySubmit({
            body,
            onSuccess: res => {
                const { processedCount, skippedCount, rejectedCount } = res.body;

                if (processedCount > 0 && rejectedCount === 0) {
                    toastHandler.push('success', t('timeTrackingView.monthlySubmit.title'), t('timeTrackingView.monthlySubmit.success'));
                }

                if (skippedCount > 0 && processedCount === 0) {
                    toastHandler.push('warn', t('timeTrackingView.monthlySubmit.title'), t('timeTrackingView.monthlySubmit.unchanged'));
                }

                if (rejectedCount > 0 && processedCount > 0) {
                    toastHandler.push('warn', t('timeTrackingView.monthlySubmit.title'), t('timeTrackingView.monthlySubmit.partialReject'));
                }

                if (rejectedCount > 0 && processedCount === 0) {
                    toastHandler.push('warn', t('timeTrackingView.monthlySubmit.title'), t('timeTrackingView.monthlySubmit.error'));
                }

                if (callback?.onSuccess) callback.onSuccess(res.body);
            },
            onError: error => {
                const normalizedError = normalizeError(error);
                toastHandler.push(
                    'warn',
                    t('timeTrackingView.monthlySubmit.title'),
                    getUserMessage(normalizedError, t('timeTrackingView.monthlySubmit.error'))
                );
                if (callback?.onError) callback.onError(error);
            },
        });

        exec();
        return abort;
    };

    return { exec };
};

export default useHttpMonthlySubmitTimelogs;
